import Link from 'src/components/primitives/Link/Link';
import { DefinitionTooltipConfig } from 'src/components/Tooltip/DefinitionTooltip/types';

/**
 * Tooltips used across the app that aren't specific to a page, dialog, or table.
 */
export const commonTooltips = {
	unsettledBalance: {
		title: 'Unsettled Balance',
		body: (
			<>
				This includes funding fees, position P&L, and referral fees. Claiming
				unsettled balances will update your available USDC balance for staking
				and withdrawals.
				<Link
					href="https://docs.drift.trade/profit-loss/what-is-unsettled-profit-loss"
					openInNewTab
				>
					Learn more
				</Link>
			</>
		),
	},
	selfImposedMaxLeverage: {
		title: 'Self-Imposed Max Leverage',
		body: 'Your max amount shown here is lower than the protocol allows due to self imposed max account leverage. You can adjust this in settings.',
	},
	stakingSubaccountWithdrawalLimits: {
		title: 'Withdrawal Limits',
		body: (
			<>
				<p>Staking from a Drift account is subject to withdrawal limits.</p>
				<p>Drift limits daily withdrawals to protect the protocol. </p>
				<Link
					href="https://docs.drift.trade/risk-and-safety/risk-parameters"
					openInNewTab
				>
					Learn more
				</Link>
			</>
		),
	},
} satisfies Record<string, DefinitionTooltipConfig>;
